// extracted by mini-css-extract-plugin
module.exports = {"circle":"TimelineItem_circle__GM4ln","text":"TimelineItem_text__IV9Uj"};